/**
 * Unified Collection Routing — FEAT-157 (BET-105 Slice 0)
 *
 * Thin client: delegates to Convex chain.resolveCollection (L5 orchestration).
 * All entry-creation surfaces call this; Convex runs LLM → heuristic → typeHint.
 *
 * Chain: DEC-163 (L5 placement), FEAT-157, FEAT-159 (confidence gating)
 */

import { kernelCall, getAgentSessionId } from "../client.js";

// ── Types (mirror Convex ResolvedCollection contract) ─────────────────────

export type ConfidenceTier = "high" | "medium" | "low";

export interface ResolvedCollection {
  collection: string;
  confidence: number;
  tier: ConfidenceTier;
  alternatives: Array<{ collection: string; confidence: number }>;
  classifiedBy: "llm" | "heuristic";
  reasoning: string;
  /** BET-288 S0: thinkingLayer of the resolved collection for confusion telemetry. */
  thinkingLayer?: string;
}

// ── Main entry point (thin client) ───────────────────────────────────────

export async function resolveCollection(params: {
  name: string;
  description: string;
  typeHint?: string;
  allowReviewRouting?: boolean;
}): Promise<ResolvedCollection | null> {
  const { name, description, typeHint, allowReviewRouting } = params;

  const sessionId = getAgentSessionId();
  const result = await kernelCall<ResolvedCollection | null>("chain.resolveCollection", {
    entryName: name,
    entryDescription: description,
    ...(typeHint ? { typeHint } : {}),
    ...(allowReviewRouting ? { allowReviewRouting } : {}),
    ...(sessionId ? { agentSessionId: sessionId } : {}),
  });

  return result ?? null;
}
